import RequestManager from "../../../requests/RequestManager";
import AddFavoriteTeamTask from "../../../requests/tasks/sports/addFavoriteTeamTask";
import logger from 'src/utils/logger/logger';

export const addFavoriteTeam = async (teamId, leagueId) => {
    try {
        const addFavoriteTeamTask = new AddFavoriteTeamTask(teamId, leagueId);
        const response = await RequestManager.addRequest(addFavoriteTeamTask);
        return response;
    }catch (error) {
        logger.error('Error adding favorite team:', error);
        throw error;
    }
}



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/services/addFavoriteTeam.js